import { useState, useEffect } from 'react'
import withDataLayer, { PAGE_TYPES } from '@components/withDataLayer'
import { config } from '@components/utils/myAccount'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { EVENTS_MAP } from '@components/services/analytics/constants'
import useAnalytics from '@components/services/analytics/useAnalytics'
import { useUI } from '@components/ui/context'
import NextHead from 'next/head'
import React from 'react'
import Wishlist from '@components/account/Wishlist'
import LayoutAccount from '@components/common/LayoutAccount'
import {
  collectionSlug,
  EmptyGuid,
  NEXT_GET_ALT_RELATED_PRODUCTS,
  NEXT_GET_ORDER_RELATED_PRODUCTS,
  NEXT_GET_WISHLIST,
  NEXT_REFERRAL_PROGRAM,
  ProdutId,
} from '@components/utils/constants'
import axios from '@services/axiosInterceptorInstance'
import dynamic from 'next/dynamic'
import { FREQUENTLY_BOUGHT_TOGETHER_BTM_BTN } from '@framework/utils/constants'
import { IPagePropsProvider } from '@framework/contracts/page-props/IPagePropsProvider'
import { PagePropType, getPagePropType } from '@framework/page-props'

const RelatedProducts = dynamic(
  () => import('@components/product/RelatedProducts'),
  { ssr: false }
)

function MyWishlist({ deviceInfo, previousPath }: any) {
  const [isReferVisible, setReferVisible] = useState(false)
  const [relatedProducts, setRelatedProducts] = useState<any>()
  const [altRelatedProducts, setAltRelatedProducts] = useState<any>()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])

  const { isGuestUser, user, deleteUser, setWishlist } = useUI()
  const router = useRouter()
  const { CustomerProfileViewed } = EVENTS_MAP.EVENT_TYPES
  const { Customer } = EVENTS_MAP.ENTITY_TYPES

  let hostName = ''

  if (typeof window !== 'undefined') {
    hostName = window?.location?.hostname ?? ''
  }

  const isUserLoggedIn =
    !isGuestUser && user?.userId && user?.userId !== EmptyGuid

  const getReferVisibiliy = async () => {
    try {
      const response: any = await axios.get(NEXT_REFERRAL_PROGRAM)
      if (
        response?.data?.result?.success &&
        response?.data?.result?.result?.referrerPromo &&
        response?.data?.result?.result?.refereePromo
      ) {
        if (!isReferVisible) {
          setReferVisible(true)
        }
      } else {
        if (isReferVisible) {
          setReferVisible(false)
        }
      }
    } catch (error: any) {
      console.error(':: error ', error)
    }
  }

  const getReferAndEarnButton = (item: any, idx: any) => {
    if (isReferVisible) {
      return (
        <>
          <div
            key={`my-acc-${idx}`}
            // href="#"
            onClick={() => item.onClick(user)}
            className={`ring-white relative ring-opacity-60 border-b border-slate-300 sm:border-0 cursor-pointer ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2  w-full text-14  leading-5 text-left pl-4 ${item.text == 'Wishlist'
                ? 'bg-white border-r-0  sm:border-b-0 sm:border-r-2 sm:border-black font-bold opacity-full'
                : 'text-primary font-medium opacity-60'
              }`}
          >
            <span className="pr-2 leading-none align-middle acc-mob-icon-i sm:absolute top-2/4 -translate-y-2/4">
              <i className={item.text.toLowerCase() + ' ' + 'sprite-icon'} />
            </span>
            <Link legacyBehavior href={item.href} passHref>
              <span className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary">
                <span className="inline-block sm:hidden">{item.mtext}</span>
                <span className="hidden sm:inline-block">{item.text}</span>
              </span>
            </Link>
          </div>
        </>
      )
    } else {
      return null
    }
  }

  let loggedInEventData: any = {
    eventType: CustomerProfileViewed,
  }

  if (user && user.userId) {
    loggedInEventData = {
      ...loggedInEventData,
      entity: JSON.stringify({
        email: user.email,
        dateOfBirth: user.yearOfBirth,
        gender: user.gender,
        id: user.userId,
        name: user.firstName + user.lastName,
        postCode: user.postCode,
      }),
      entityId: user.userId,
      entityName: user.firstName + user.lastName,
      entityType: Customer,
    }
  }

  useAnalytics(CustomerProfileViewed, loggedInEventData)

  useEffect(() => {
    const getAltrelatedProduct = async () => {
      const { data: altRelatedProducts }: any = await axios.post(
        NEXT_GET_ALT_RELATED_PRODUCTS,
        {
          slug: collectionSlug,
        }
      )
      setAltRelatedProducts(altRelatedProducts)
    }

    const fetchRelatedProducts = async () => {
      const { data: relatedProducts }: any = await axios.post(
        NEXT_GET_ORDER_RELATED_PRODUCTS,
        {
          id: ProdutId,
        }
      )
      setRelatedProducts(relatedProducts)
    }
    getReferVisibiliy()
    fetchRelatedProducts()
    getAltrelatedProduct()
  }, [])

  const fetchItems = async () => {
    !isLoading && setIsLoading(true)
    try {
      const response: any = await axios.post(NEXT_GET_WISHLIST, {
        id: user.userId,
        flag: true,
      })
      setIsLoading(false)
      setData(response.data)
      setWishlist(response.data)
    } catch (error) {
      console.error(':: error ', error)
      setIsLoading(false)
    }
  }

  // useEffect(() => {
  //   fetchItems()
  // }, [])

  const relatedProductData = relatedProducts?.relatedProducts?.filter(
    (x: any) => x?.itemType != 10
  )

  return (
    <>
      {hostName && <input className="inst" type="hidden" value={hostName} />}
      <h1 className="hidden">Wishlist</h1>
      <NextHead>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <link
          rel="canonical"
          id="canonical"
          href={'https://www.damensch.com' + router.asPath}
        />
        <title>Wishlist</title>
        <meta name="title" content="Wishlist" />
        <meta name="description" content="Wishlist" />
        <meta name="keywords" content="Wishlist" />
        <meta property="og:image" content="Wishlist image" />
        <meta property="og:title" content="Wishlist" key="ogtitle" />
        <meta property="og:description" content="Wishlist" key="ogdesc" />
      </NextHead>
      <section className="relative pb-10 text-gray-900">
        <div className="w-full px-0 mx-auto accunt-main-container sm:px-0 lg:px-0">
          <div className="grid w-full grid-cols-12 px-0 sm:px-0 md:px-2 sm:pr-0 main-account-grid">
            <div className="col-span-3 pl-0 border-r border-gray-200 sm:pl-6 tab-list-sm sm:pt-10 mob-hidden">
              <div className="sticky left-0 z-10 flex flex-col top-36">
                {config.map((item: any, idx: number) => {
                  if (item?.props === 'refer-earn') {
                    return getReferAndEarnButton(item, idx)
                  } else {
                    return (
                      <>
                        <div
                          key={`my-acc-${idx}`}
                          onClick={() => item.onClick(user)}
                          className={`ring-white relative ring-opacity-60 border-b border-slate-300 sm:border-0 cursor-pointer ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2  w-full text-14  leading-5 text-left pl-4 ${item.text == 'Wishlist'
                              ? 'bg-white border-r-0  sm:border-b-0 sm:border-r-2 sm:border-black font-bold opacity-full'
                              : 'text-primary font-medium opacity-60'
                            }`}
                        >
                          <span className="pr-2 leading-none align-middle acc-mob-icon-i sm:absolute top-2/4 -translate-y-2/4">
                            <i
                              className={
                                item.text.toLowerCase() + ' ' + 'sprite-icon'
                              }
                            />
                          </span>
                          <Link legacyBehavior href={item.href} passHref>
                            <span className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary">
                              <span className="inline-block sm:hidden">
                                {item.mtext}
                              </span>
                              <span className="hidden sm:inline-block">
                                {item.text}
                              </span>
                            </span>
                          </Link>
                        </div>
                      </>
                    )
                  }
                })}
                {isUserLoggedIn ? (
                  <div
                    key={`my-acc-logout`}
                    onClick={() => deleteUser()}
                    className="relative w-full pl-4 leading-5 text-left border-b cursor-pointer ring-white ring-opacity-60 border-slate-300 sm:border-0 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2 text-14 opacity-60"
                  >
                    <span className="pr-2 leading-none align-middle acc-mob-icon-i sm:absolute top-2/4 -translate-y-2/4">
                      <i className="sprite-icon sprite-logout"></i>
                    </span>
                    <Link
                      legacyBehavior
                      key="logout"
                      href=""
                      passHref
                      shallow={true}
                    >
                      <span
                        className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary"
                        onClick={() => deleteUser()}
                      >
                        Logout
                      </span>
                    </Link>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="relative col-span-9 border-l tabpanel-sm mob-tab-full">
              <div className={'orders bg-white'}>
                <Wishlist previousPath={previousPath} />
              </div>
            </div>
          </div>
        </div>
        {isUserLoggedIn ? (
          <>
            {data.length == 0 &&
              altRelatedProducts?.relatedProducts?.products?.results?.length ? (
              <>
                <div className="flex flex-col">
                  <div className="section-devider" />
                </div>
                <div className="w-full px-4 sm:container sm:mx-auto sm:px-6">
                  <RelatedProducts
                    relatedProducts={
                      altRelatedProducts?.relatedProducts?.products?.results
                    }
                    productPerColumn={5}
                    checkout_refrence={false}
                    title="You May Also Like"
                    deviceInfo={deviceInfo}
                    showBtmBtn={FREQUENTLY_BOUGHT_TOGETHER_BTM_BTN}
                  />
                </div>
              </>
            ) : relatedProductData?.length ? (
              <>
                <div className="w-full px-4 sm:container sm:mx-auto sm:px-6">
                  <RelatedProducts
                    relatedProducts={relatedProductData}
                    productPerColumn={5}
                    checkout_refrence={false}
                    title="You May Also Like"
                    deviceInfo={deviceInfo}
                    showBtmBtn={FREQUENTLY_BOUGHT_TOGETHER_BTM_BTN}
                  />
                </div>
              </>
            ) : null}
          </>
        ) : null}
      </section>
    </>
  )
}

MyWishlist.Layout = LayoutAccount

const PAGE_TYPE = PAGE_TYPES.Page

export async function getServerSideProps(context: any) {
  const defaultIndex =
    config.findIndex((element: any) => element.props === context.query.view) ||
    0
  const props: IPagePropsProvider = getPagePropType({ type: PagePropType.COMMON }) as IPagePropsProvider
  const commonPageProps = await props.getPageProps({ cookies: {} })
  return {
    props: {
      ...commonPageProps,
      defaultView: defaultIndex,
    }, // will be passed to the page component as props
  }
}

export default withDataLayer(MyWishlist, PAGE_TYPE, true, LayoutAccount)
